const RULE_TITLE_KEYS: Record<string, string> = {
  REFRIGERANT_LEAK: 'ruleRefrigerantLeakTitulo',
  FREEZING_RISK: 'ruleFreezeRiskTitulo',
  COMPRESSOR_INEFFICIENT: 'ruleCompressorInefficientTitulo',
  CHILLED_WATER_TEMP_HIGH: 'ruleChilledWaterTempHighTitulo',
  LOW_COOLING_CAPACITY: 'ruleLowCoolingCapacityTitulo',
  SHOULD_BE_ON: 'ruleShouldBeOnTitulo',
};

const RULE_CAUSE_KEYS: Record<string, string> = {
  REFRIGERANT_LEAK: 'ruleRefrigerantLeakCausa',
  FREEZING_RISK: 'ruleFreezeRiskCausa',
  COMPRESSOR_INEFFICIENT: 'ruleCompressorInefficientCausa',
};

export function getRuleTitleKey(ruleCode: string | null | undefined): string {
  if (ruleCode && RULE_TITLE_KEYS[ruleCode]) {
    return RULE_TITLE_KEYS[ruleCode];
  }
  return 'problemaDetectado';
}

export function getRuleCauseKey(ruleCode: string | null | undefined): string | null {
  if (ruleCode && RULE_CAUSE_KEYS[ruleCode]) {
    return RULE_CAUSE_KEYS[ruleCode];
  }
  return null;
}
